import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=01c099c3&scoped=true"
import script from "./DocumentEdit.vue?vue&type=script&lang=js"
export * from "./DocumentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c099c3",
  null
  
)

export default component.exports